/**
 * MessageStatus Component
 * Indicatori di stato messaggio (check singolo, doppio, blu)
 */

import { memo } from 'react';
import { Check, CheckCheck, Clock } from 'lucide-react';
import type { MessageStatus as Status } from '@/lib/types/whatsappChat';

interface MessageStatusProps {
  status: Status;
  isOutbound?: boolean;
  className?: string;
}

export const MessageStatus = memo(function MessageStatus({
  status,
  isOutbound = false,
  className = '',
}: MessageStatusProps) {
  const baseClass = `w-3 h-3 ${className}`;

  // Colori stile WhatsApp: grigio per pending/sent/delivered, blu per read
  const pendingColor = 'text-[#667781] dark:text-[#8696A0]';
  const sentColor = 'text-[#667781] dark:text-[#8696A0]';
  const deliveredColor = 'text-[#667781] dark:text-[#8696A0]';
  const readColor = 'text-[#53BDEB]';

  switch (status) {
    case 'pending':
      return <Clock className={`${baseClass} ${pendingColor}`} />;
    case 'sent':
      return <Check className={`${baseClass} ${sentColor}`} />;
    case 'delivered':
      return <CheckCheck className={`${baseClass} ${deliveredColor}`} />;
    case 'read':
    case 'played':
      return <CheckCheck className={`${baseClass} ${readColor}`} />;
    case 'failed':
      return <span className={`${baseClass} text-red-500 text-xs`}>!</span>;
    default:
      return null;
  }
});
